import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import {toast} from 'react-toastify'
import  UploadImage from '../UploadImage'
import MultipleImage from '../MultipleUpload'
import UserName from '../Dropdowns/Username'
import axiosInstance from '../../axios'
import MultiSelect from "../Dropdowns/MultiSelect";
import MultiSectors from '../Dropdowns/AllSectors'
import District from '../Dropdowns/District'
import State from '../Dropdowns/States'
export default function UpdateCentre({
  updateProductData,
  updateModalSetting,
}) {
  const {
    centre_id,
    centre_name,
    vtp_no,
    vtp_id,
    centre_address,
    landmark,
    tan_no,
    city,
    centre_images,
    tahsil ,
    district ,
    state,
    bank_name,
    bank_acc_no ,
    ifsc_code ,
    branch ,
    pan_no ,
    pmkvy_partner,
    cp_id ,
    cp_name ,
    cp_mo_no,
    cp_email ,
    cp_address,
    financial_year ,
    agreement_file,
    guarantee_file,
    cp_profile_image,
    documents,
    deposit_file,
    receipt_file,
    cheque_file,
    centre_category ,
    pin_code,
    scheme_ids,
    centre_status,
    username
  } = updateProductData;
  const[err,setErr]=useState(false)
  const [selectedScheme, setSelectedScheme] = useState(scheme_ids);
  const[selectedSectors,setSelectedSectors]=useState([])
  const[cstate,setState]=useState(state)
  const [cdistrict,setDistrict]=useState(district)
const imp=false
const dont=true
  const [image,setImage]=useState(centre_images||[])
  const[profile,setProfile]=useState(cp_profile_image)
  const[tdocument,setDocument]=useState(documents)
  const[tagreement,setAgreement]=useState(agreement_file)
  const[treceipt,setReceipt]=useState(receipt_file)
  const[tcheque,setCheque]=useState(cheque_file)
  const[cid,setCid]=useState(cp_id)
  const cStatus = centre_status === 1 ? "1" : "0";
  const[cstatus,setStatus]=useState(cStatus)
  const[tdeposite,setDeposite]=useState(deposit_file)
  const[tguarantee,setGurantee]=useState(guarantee_file)
const [centre,setCentre]=useState({
    centre_name:centre_name,
    centre_address:centre_address,
    landmark:landmark,
    centre_images:centre_images,
    city:city,
    tahsil :tahsil,
    bank_name:bank_name,
    bank_acc_no :bank_acc_no,
    ifsc_code :ifsc_code,
    branch :branch,
    pan_no :pan_no,
    tan_no:tan_no,
    pmkvy_partner:pmkvy_partner,
    cp_name :cp_name,
    cp_mo_no:cp_mo_no,
    cp_email :cp_email,
    cp_address:cp_address,
    financial_year :financial_year,
    centre_category :centre_category,
    pin_code:pin_code,

})
const handleCourseChange = (newSelectedScheme) => {
  setSelectedScheme(newSelectedScheme);
};
const handleSectorsChange=(newSelectedSectors)=>{
  setSelectedSectors(newSelectedSectors)
}
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCentre(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleCid=(e)=>{
    setCid(e.target.value)
  }
  const handleImagesChange = (newImages) => {
    setImage(newImages);
  };
  const handleProfileChange = (e) => {
    setProfile(e.target.files[0]);
  };
  const handleReciept=(e)=>{
    setReceipt(e.target.files[0]);
  }
  const handleDocumentChange = (e) => {
    setDocument(e.target.files[0]);
  };
  const handleAgreementChange = (e) => {
    setAgreement(e.target.files[0]);
  };
  const handleChequeChange = (e) => {
    setCheque(e.target.files[0]);
  };
  const handleDepositeChange = (e) => {
    setDeposite(e.target.files[0]);
  };
  const handleGuaranteeChange = (e) => {
    setGurantee(e.target.files[0]);
  };
  const statusBit = cstatus === "1" ? 1 : 0;
  const updateProduct = () => {
   
    const form=new FormData()
    form.append('centre_name', centre.centre_name);
    form.append('centre_address', centre.centre_address)
    for(let i=0;i<image.length;i++){
      form.append('centre_images', image[i])
    }
    
    form.append('city', centre.city);
    form.append('tahsil', centre.tahsil);
    form.append('landmark', centre.landmark);
    form.append('district', cdistrict);
    form.append('state', cstate);
    form.append('bank_name', centre.bank_name);
    form.append('bank_acc_no', centre.bank_acc_no);
    form.append('ifsc_code', centre.ifsc_code);
    form.append('branch', centre.branch);
    form.append('pan_no', centre.pan_no);
    form.append('tan_no', centre.tan_no);
    form.append('pmkvy_partner', centre.pmkvy_partner);
    form.append('cp_name', centre.cp_name);
    form.append('cp_mo_no', centre.cp_mo_no);
    form.append('cp_email', centre.cp_email);
    form.append('cp_address', centre.cp_address);
    form.append('cp_profile_image', profile);
    form.append('documents', tdocument);
    form.append('deposit_file', tdeposite);
    form.append('receipt_file', treceipt);
    form.append('cheque_file', tcheque);
    form.append('agreement_file', tagreement);
    form.append('guarantee_file', tguarantee);
    form.append('financial_year', centre.financial_year);
    form.append('centre_category', centre.centre_category);
    form.append('pin_code', centre.pin_code);
    form.append('scheme_id', selectedScheme)
    form.append('centre_status',statusBit)
    form.append('sector_name',selectedSectors)
    axiosInstance.put(`/trainingcentre/update/${centre_id}`,form)
    .then((res) => {
      toast.success(res.data.message)
     
      updateModalSetting(false);
    })
    .catch((err)=>{
       console.log(err);
       toast.error('Error updating Centre')
 
    })
    // Your code for updating product goes here

    // Close the modal after successful update
    setOpen(false);
  }

  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg
               bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-5xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Update Centre
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4  sm:grid-cols-5">
                          
                        <div>
                            <label
                           className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                            >Centre Images</label>
                            <MultipleImage onImagesChange={handleImagesChange} />
                          </div>

                          <div>
                            <label
                              htmlFor="centre_name"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Centre Name
                            </label>
                            <input
                            type="text"
                            name="centre_name"
                            id="centre_name"
                            value={centre.centre_name}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                          </div>
                          <div>
                            <label
                              htmlFor="vtpno"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                       SIP ID
                            </label>
                            <input
                              type="text"
                              name="vtpno"
                              id="vtpno"
                              value={vtp_no}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                          </div>
                           <div>
                            <label
                              for="vtpid"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                            VTP  ID
                            </label>
                            <input
                              type="text"
                              id="vtpid"
                              name="vtpid"
                              value={vtp_id}
                              disabled
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                          </div>
                          <div>
                            <label
                              for="centre_category"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                            >
                              Category
                            </label>
                            <input
                              type="text"
                              name="centre_category"
                              id="centre_category"
                              value={centre.centre_category}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            
                            />
                          </div>
                         

                          <div>
                          <label htmlFor="pmkvy_partner" 
                                                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
>
            Partner Agency
          </label>
          <input
            type="text"
            id="pmkvy_partner"
            name="pmkvy_partner"
            value={centre.pmkvy_partner}
            onChange={handleInputChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                            </div>
                            <div>
                              <label
                                htmlFor="centre_address"
                                                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                              >
                                Address
                              </label>
                              <input
                                type="text"
                                id="centre_address"
                                name="centre_address"
                                value={centre.centre_address}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                aria-autocomplete="true"
                              />
                            </div>
                            <div>
                            <State handleChange={e=>setState(e.target.value)} value={cstate} imp={imp}/>
                            </div>
                            <div>
                              <District selectedState={cstate} 
                              handleChange={e=>setDistrict(e.target.value)} 
                              value={cdistrict} imp={imp}/>
                            </div>
                            <div>
                              <label htmlFor="city"
                                                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                               >
                                City
                               </label>
                               <input type="text"
                              id="city"
                              name="city"
                              value={centre.city}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                              :focus:border-blue-500"
                              />
                            </div>
                            
                            <div>
                              <label htmlFor="pin_code"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                              >Pincode</label>
                              <input type="text"
                              id="pin_code"
                              name="pin_code"
                              value={centre.pin_code}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                              :focus:border-blue-500"
                              />
                            </div>
                            <div>
                              <label htmlFor="landmark"                               
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >Landmark</label>
                              <input
                              type="text"
                              id="landmark"
                              name="landmark"
                              value={centre.landmark}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                              :focus:border-blue-500"
                              />
                            </div>
                            <div>
                            <label
                              htmlFor="tahsil"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Tehsil
                            </label>
                            <input 
                            type="text"
                            name="tahsil"
                            id="tahsil"
                            value={centre.tahsil}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                         
                            <div>
                            <label
                              htmlFor="pan_no"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Pan No.
                            </label>
                            <input
                            type="text"
                            name="pan_no"
                            id="pan_no"
                            value={centre.pan_no}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label
                              htmlFor="tan_no"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Tan No.
                            </label>
                            <input 
                            type="text"
                            name="tan_no"
                            id="tan_no"
                            value={centre.tan_no}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                            <div>
                          <label
                          htmlFor="contactperson"
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >Contact Person Photo</label>
                          <UploadImage uploadImage={handleProfileChange} fileName={profile}/>
                              </div>
                           
                          <div>
                                <label htmlFor="cp_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Contact Person Name</label>
                                <input
                                type="text"
                                id="cp_name"
                                name="cp_name"
                                value={centre.cp_name}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>

                            
                              
                          </div>
                          <div>
                                <label htmlFor="cp_mo_no"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Contact Person Mobile</label>
                                <input
                                type="text"
                                id="cp_mo_no"
                                name="cp_mo_no"
                                value={centre.cp_mo_no}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>

                            
                              
                          </div>
                          <div>
                                <label htmlFor="cp_email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Contact Person Email</label>
                                <input
                                type="text"
                                id="cp_email"
                                name="cp_email"
                                value={centre.cp_email}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>

                            
                              
                          </div>
                          <div>
                                <label htmlFor="cp_address" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Contact Person Address</label>
                                <input
                                type="text"
                                id="cp_address"
                                name="cp_address"
                                value={centre.cp_address}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>

                            
                              
                          </div>
                          <div>
                            <label htmlFor="bank_name"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Name</label>
                            <input
                            type="text"
                            name="bank_name"
                            id="bank_name"
                            value={centre.bank_name}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
                            <label htmlFor="bank_acc_no"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Account No.</label>
                            <input
                            type="text"
                            name="bank_acc_no"
                            id="bank_acc_no"
                            value={centre.bank_acc_no}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
                            <label htmlFor="ifsc_code"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank IFSC</label>
                            <input
                            type="text"
                            name="ifsc_code"
                            id="ifsc_code"
                            value={centre.ifsc_code}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
                            <label htmlFor="branch"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Branch</label>
                            <input
                            type="text"
                            name="branch"
                            id="branch"
                            value={centre.branch}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
                            <label htmlFor="recipt"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Receipt</label>
                            <label
        htmlFor="recipt"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {treceipt?.name && treceipt.name.length > 8
            ? treceipt.name.substring(0, 8) + "..."
            : treceipt?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="recipt"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleReciept}
      />
                          </div>
                          <div>
                            <label htmlFor="document"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Documents</label>
                            <label
        htmlFor="document"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {tdocument?.name && tdocument.name.length > 8
            ? tdocument.name.substring(0, 8) + "..."
            : tdocument?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="document"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleDocumentChange}
      />
                          </div>
                          <div>
                            <label htmlFor="agreement"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Agreement</label>
                           <label
        htmlFor="agreement"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {tagreement?.name && tagreement.name.length > 8
            ? tagreement.name.substring(0, 8) + "..."
            : tagreement?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="agreement"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleAgreementChange}
      />
                          </div>
                          <div>
                            <label htmlFor="cheque"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Cheque</label>
                           <label
        htmlFor="cheque"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {tcheque?.name && tcheque.name.length > 8
            ? tcheque.name.substring(0, 8) + "..."
            : tcheque?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="cheque"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleChequeChange}
      />
                          </div>
                          <div>
                            <label htmlFor="deposite"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Deposit</label>
                          <label
        htmlFor="deposite"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {tdeposite?.name && tdeposite.name.length > 8
            ? tdeposite.name.substring(0, 8) + "..."
            : tdeposite?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="deposite"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleDepositeChange}
      />
                          </div>
                          <div>
                            <label htmlFor="guarantee"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Guarantee</label>
                           <label
        htmlFor="guarantee"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {tguarantee?.name && tguarantee.name.length > 8
            ? tguarantee.name.substring(0, 8) + "..."
            : tguarantee?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="guarantee"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleGuaranteeChange}
      />
                          </div>
                      
                           <div>
                            <label htmlFor="status"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Status</label>
                                <select
                id="status"
                value={cstatus}
                onChange={e=>setStatus(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' disabled>------Select-----</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
               


            </select>
                            </div>
                            <div>
                            <label htmlFor="fyear"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Financial Year</label>
                            <input
                            type="text"
                            name='financial_year'
                            value={centre.financial_year}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                            <div className="lg:row-span-12">
                            <MultiSelect
        selectedCourses={selectedScheme}
        onChange={handleCourseChange}
        isDisabled={false}
      />
                           </div>
                           <div className="lg:row-span-12 lg:col-span-2">
                          <MultiSectors
        selectedCourses={selectedSectors}
        onChange={handleSectorsChange}
        centre_id={centre_id}
      />
                           </div>
                       
                            
                        </div>
                        <div className="flex items-center space-x-4">
                          {/* <button
                            type="submit"
                            className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                          >
                            Update product
                          </button> */}
                          {/* <button
                            type="button"
                            className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                          >
                            <svg
                              className="mr-1 -ml-1 w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            Delete
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={updateProduct}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => updateModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
